import useApi from 'hooks/useApi'
import { CREATE_LEAD_FROM_NEWSLETTER_ROUTE } from 'dataSource/salesforce/routes'
import { Req } from 'use-http'

type SFLeadFromNewsletter = Partial<SfLead>

// Right now we are using this only to generate lead from the newsletter footer form.
const useCreateSalesforceLead = (): ((
  lead: SFLeadFromNewsletter
) => Promise<unknown>) => {
  const { request: leadRequest } = useApi({
    redirectOnUnauthorized: false,
  })

  const handleSubmitLead = async (lead: SFLeadFromNewsletter) => {
    return await getSFResponse(leadRequest, { ...lead })
  }

  return handleSubmitLead
}

const getSFResponse = async (
  leadRequest: Req,
  body: BodyInit | Record<string, unknown>
) => {
  const response = await leadRequest.post(
    CREATE_LEAD_FROM_NEWSLETTER_ROUTE,
    body
  )

  if (!response) {
    throw new Error('Unable to create lead from newsletter')
  }

  if (response?.statusCode === 401) {
    throw new Error('Unauthorized')
  }

  return response
}

export default useCreateSalesforceLead
